import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { LoginComponent } from "@app/landing/login/login.component";

import { SharedService } from "@app/services/net-remit/shared-functions.service";

@Component({
  selector: 'app-mfa',
  templateUrl: './mfa.component.html',
  styleUrls: ['./mfa.component.scss'],
  standalone: false
})
export class MfaComponent implements OnInit {

  code: string;
  qrCodeImage: string;

  @ViewChild(LoginComponent) loginComponent;
  @Input() currentLanguage: string;
  @Output() toggleShowMFAInformationMethod = new EventEmitter<boolean>();

  constructor(
      private sharedService: SharedService
  ) {

  }

  ngOnInit() {
    this.observableQRImage();
  }

  public toggleShowMFAInformation(value: boolean){
    this.toggleShowMFAInformationMethod.emit(value);
  }

  public showMicrosoftAuthenticatorInfo(){
    const url = `https://www.microsoft.com/${this.currentLanguage}/security/mobile-authenticator-app`;
    window.open(url, '_blank');
  }

  private observableQRImage(){
    this.sharedService.data$.subscribe((response) => {
      if (response != null) {
        this.qrCodeImage = response.img;
        this.code = response.code;
      }
    });
  }
}
